// extracted by mini-css-extract-plugin
module.exports = {"container":"container--1uv6QX","info":"info--3nUosH","label":"label--1vAtAB","value":"value--3zJSt0"};